import { session, appState } from './config.js';
import { apiGet } from './api.js';
import { go } from './router.js';

export const OFFICIAL_ROUTES=['dashboard','sha-plant','thu-plant'];

export const canDelete=()=>session.role==='unofficial';

export function applyRole(){
  document.querySelectorAll('[data-role]').forEach(el=>{const needs=el.dataset.role;el.style.display=(needs==='unofficial'&&session.role!=='unofficial')?'none':''});
  const b=document.getElementById('roleBadge');if(b){b.textContent=session.role==='official'?'Official':'Unofficial';b.className='rolepill '+session.role}
  const c=document.getElementById('companyLbl');if(c)c.innerHTML=`<b>${session.user||'SSREC'}</b> · ${session.company||'SSREC Plants'}${appState.OFFLINE?' · <span style="color:var(--gold-d)">offline demo</span>':''}`;
}

export async function doLogin(){
  const u=document.getElementById('u').value.trim(),p=document.getElementById('p').value.trim();
  const err=document.getElementById('loginErr');err.textContent='';
  if(!u||!p){err.textContent='Enter username and password.';return}
  try{
    const res=await apiGet('Login.php',{UserID:u,Password:p});
    if(res.status===401){err.textContent='Unauthorized user.';return}
    const data=await res.json();
    if(Array.isArray(data)&&data.length){
      const me=data[0];appState.OFFLINE=false;
      Object.assign(session,{IMIE:me.IMIE,user:me.UserName,company:me.Company,typed:me.Typed,role:(String(me.Typed||'').toLowerCase()==='official'?'official':'unofficial')});
      enterApp();
    } else {err.textContent='Unauthorized user.'}
  }catch(e){
    // server unreachable -> offline demo using bundled data
    const demoRole = u.toLowerCase()==='official' ? 'official' : 'unofficial';
    appState.OFFLINE=true;
    Object.assign(session,{IMIE:'DEMO',user:u||'Demo',company:'SSREC Plants',typed:demoRole,role:demoRole});
    enterApp();
  }
}

export function enterApp(){
  document.getElementById('login').classList.add('hidden');
  document.getElementById('app').classList.remove('hidden');
  applyRole();go('dashboard');
}

export function logout(){document.getElementById('app').classList.add('hidden');document.getElementById('login').classList.remove('hidden');document.getElementById('u').value='';document.getElementById('p').value='';document.getElementById('loginErr').textContent='';Object.assign(session,{IMIE:'',user:'',company:'',typed:'',role:'unofficial'})}

export function toggleFs(){if(!document.fullscreenElement)document.documentElement.requestFullscreen?.();else document.exitFullscreen?.()}

/* ---------- TOAST ---------- */
